import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  createTicketMessage,
  getAllTickets,
  getTicketMessages,
} from "../../api/tickets";
import Navigation from "../Navigation";
import { XMarkIcon } from "@heroicons/react/24/outline";
import Notification from "../Notification";
import Loading from "../loading";
import TicketMessage from "./ticketMessage";

const TicketsList = () => {
  const [tickets, setTickets] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedTicket, setSelectedTicket] = useState(null);
  const [ticketMessages, setTicketMessages] = useState([]);
  const [messagesLoading, setMessagesLoading] = useState(false);
  const [refreshTokens, setRefreshTokens] = useState(false);

  useEffect(() => {
    const fetchTickets = async () => {
      try {
        const res = await getAllTickets();
        setTickets(res.data.tickets || []);
      } catch (err) {
        console.error("❌ خطا در دریافت تیکت‌ها:", err);
      } finally {
        setLoading(false);
      }
    };
    fetchTickets();
  }, [refreshTokens]);

  const fetchTicketMessages = async (ticketId) => {
    setMessagesLoading(true);
    try {
      const res = await getTicketMessages(ticketId);
      setTicketMessages(res.data.messages || []);
    } catch (err) {
      console.error("❌ خطا در دریافت پیام‌های تیکت:", err);
    } finally {
      setMessagesLoading(false);
    }
  };

  const handleTicketClick = async (ticket) => {
    setSelectedTicket(ticket);
    await fetchTicketMessages(ticket._id);
  };

  const closeModal = () => {
    setSelectedTicket(null);
    setTicketMessages([]);
  };

  const formatDate = (date) =>
    new Date(date).toLocaleString("fa-IR", {
      year: "numeric",
      month: "numeric",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });

  const pendingTickets = tickets
    .filter((ticket) => ticket.status === "pending")
    .sort((a, b) => new Date(a.lastActivity) - new Date(b.lastActivity));
    
  const needReplyTickets = tickets
    .filter(
      (ticket) => ticket.status === "open" || ticket.status === "userAnswered"
    )
    .sort((a, b) => new Date(a.lastActivity) - new Date(b.lastActivity));
  const answeredTickets = tickets
    .filter((ticket) => ticket.status === "adminAnswered")
    .sort((a, b) => new Date(a.lastActivity) - new Date(b.lastActivity));

  if (loading) {
    <Loading />;
  }

  return (
    <div className="min-h-screen bg-gray-50 py-6">
      {/* مودال نمایش پیام‌های تیکت */}
      {selectedTicket ? (
        <div className="container mx-auto px-4">
          <div className="flex flex-row w-full lg:flex-row gap-6">
            {/* نوار کناری */}
            <div className="w-full md:w-1/4 mb-6 lg:mb-0">
              <Navigation />
            </div>

            <div className=" w-full md:w-3/4 flex items-center justify-center">
              {/* لیست پیام‌ها */}
              {messagesLoading ? (
                <div className="flex justify-center items-center py-8">
                  <div className="animate-spin rounded-full h-8 w-8 border-t-2 border-b-2 border-blue-500"></div>
                  <span className="mr-3 text-gray-600">
                    در حال بارگذاری پیام‌ها...
                  </span>
                </div>
              ) : ticketMessages.length > 0 ? (
                <TicketMessage
                  selectedTicket={selectedTicket}
                  ticketMessages={ticketMessages}
                  messagesLoading={messagesLoading}
                  setLoading={setLoading}
                  setTicketMessages={setTicketMessages}
                  closeModal={closeModal}
                  fetchTicketMessages={fetchTicketMessages}
                  setRefreshTokens={setRefreshTokens}
                />
              ) : (
                <div className="flex-1 flex items-center justify-center text-gray-500">
                  هیچ پیامی در این تیکت ثبت نشده است.
                </div>
              )}
            </div>
          </div>
        </div>
      ) : (
        <div className="container mx-auto px-4">
          <div className="flex flex-row w-full lg:flex-row gap-6">
            {/* نوار کناری */}
            <div className="w-full md:w-1/4 mb-6 lg:mb-0">
              <Navigation />
            </div>

            {/* محتوای اصلی */}
            <div className="w-full md:w-3/4">
              <div className="bg-white rounded-2xl shadow-lg border-gray-100 overflow-hidden">
                {/* لیست تیکت‌ها */}
                <div className="p-6 ">
                  <h2 className="text-xl font-bold text-gray-800  ">
                    لیست تیکت‌ها ({tickets.length})
                  </h2>

                  {tickets.length ? (
                    <div className="space-y-8 mt-6">
                      {/* بخش اول: تیکت‌های با status pending */}
                      {pendingTickets.length > 0 && (
                        <div>
                          <h2 className="text-lg font-bold text-gray-800 my-4 pb-2 border-b border-gray-200">
                            در انتظار بررسی ({pendingTickets.length})
                          </h2>
                          <div className="space-y-4">
                            {pendingTickets.slice().map((ticket) => (
                              <div
                                key={ticket._id}
                                className="border border-gray-200 bg-white hover:shadow-lg transition-all p-5 rounded-xl cursor-pointer transform hover:-translate-y-0.5"
                                onClick={() => handleTicketClick(ticket)}
                              >
                                <div className="flex justify-between items-start mb-3">
                                  <div className="flex-1">
                                    <h3 className="font-bold text-gray-800 text-lg mb-2">
                                      {ticket.ticketTitle || "بدون عنوان"}
                                    </h3>
                                  </div>
                                  <span className="px-3 py-1 text-xs rounded-full font-medium bg-yellow-100 text-yellow-700">
                                    در حال بررسی
                                  </span>
                                </div>

                                <div className="flex flex-col pt-5 sm:flex-row sm:items-center justify-between text-sm text-gray-500 border-t border-gray-100">
                                  <div className="flex items-center gap-4">
                                    <span className="flex items-center gap-1">
                                      <span>📱</span>
                                      {ticket.authorId?.phone || "نامشخص"}
                                    </span>
                                    <span className="flex items-center gap-1">
                                      <span>👤</span>
                                      {ticket.authorId?.name || "کاربر"}
                                    </span>
                                  </div>
                                  <span className="flex items-center gap-1 mt-2 sm:mt-0">
                                    <span>📅</span>
                                    {formatDate(ticket.created_at)}
                                  </span>
                                </div>
                              </div>
                            ))}
                          </div>
                        </div>
                      )}

                      {/* بخش دوم: تیکت‌های با status open یا userAnswered */}
                      {needReplyTickets.length > 0 && (
                        <div>
                          <h2 className="text-lg font-bold text-gray-800 my-4 pb-2 border-b border-gray-200">
                            نیاز به پاسخ ({needReplyTickets.length})
                          </h2>
                          <div className="space-y-4">
                            {needReplyTickets.slice().map((ticket) => (
                              <div
                                key={ticket._id}
                                className="border border-gray-200 bg-white hover:shadow-lg transition-all p-5 rounded-xl cursor-pointer transform hover:-translate-y-0.5"
                                onClick={() => handleTicketClick(ticket)}
                              >
                                <div className="flex justify-between items-start mb-3">
                                  <div className="flex-1">
                                    <h3 className="font-bold text-gray-800 text-lg mb-2">
                                      {ticket.ticketTitle || "بدون عنوان"}
                                    </h3>
                                  </div>
                                  <span
                                    className={`px-3 py-1 text-xs rounded-full font-medium 
                                          ${
                                            ticket.status === "open"
                                              ? " bg-green-500 text-white "
                                              : "bg-blue-500 text-white "
                                          }
                                        `}
                                  >
                                    {ticket.status === "open"
                                      ? "تازه باز شده"
                                      : "پاسخ کاربر"}
                                  </span>
                                </div>

                                <div className="flex flex-col pt-5 sm:flex-row sm:items-center justify-between text-sm text-gray-500 border-t border-gray-100">
                                  <div className="flex items-center gap-4">
                                    <span className="flex items-center gap-1">
                                      <span>📱</span>
                                      {ticket.authorId?.phone || "نامشخص"}
                                    </span>
                                    <span className="flex items-center gap-1">
                                      <span>👤</span>
                                      {ticket.authorId?.name || "کاربر"}
                                    </span>
                                  </div>
                                  <span className="flex items-center gap-1 mt-2 sm:mt-0">
                                    <span>📅</span>
                                    {formatDate(ticket.created_at)}
                                  </span>
                                </div>
                              </div>
                            ))}
                          </div>
                        </div>
                      )}

                      {/* بخش سوم: تیکت‌های با status adminAnswered */}
                      {answeredTickets.length > 0 && (
                        <div>
                          <h2 className="text-lg font-bold text-gray-800 my-4  pb-2 border-b border-gray-200">
                            پاسخ داده شده ({answeredTickets.length})
                          </h2>
                          <div className="space-y-4">
                            {answeredTickets.slice().map((ticket) => (
                              <div
                                key={ticket._id}
                                className="border border-gray-200 bg-white hover:shadow-lg transition-all p-5 rounded-xl cursor-pointer transform hover:-translate-y-0.5"
                                onClick={() => handleTicketClick(ticket)}
                              >
                                <div className="flex justify-between items-start mb-3">
                                  <div className="flex-1">
                                    <h3 className="font-bold text-gray-800 text-lg mb-2">
                                      {ticket.ticketTitle || "بدون عنوان"}
                                    </h3>
                                  </div>
                                  <span className="px-3 py-1 text-xs rounded-full font-medium bg-green-100 text-green-700">
                                    پاسخ داده شده
                                  </span>
                                </div>

                                <div className="flex flex-col pt-5 sm:flex-row sm:items-center justify-between text-sm text-gray-500 border-t border-gray-100">
                                  <div className="flex items-center gap-4">
                                    <span className="flex items-center gap-1">
                                      <span>📱</span>
                                      {ticket.authorId?.phone || "نامشخص"}
                                    </span>
                                    <span className="flex items-center gap-1">
                                      <span>👤</span>
                                      {ticket.authorId?.name || "کاربر"}
                                    </span>
                                  </div>
                                  <span className="flex items-center gap-1 mt-2 sm:mt-0">
                                    <span>📅</span>
                                    {formatDate(ticket.created_at)}
                                  </span>
                                </div>
                              </div>
                            ))}
                          </div>
                        </div>
                      )}
                    </div>
                  ) : (
                    <div className="text-center py-12">
                      <div className="mx-auto w-24 h-24 bg-gray-100 rounded-full flex items-center justify-center mb-4">
                        <svg
                          className="w-10 h-10 text-gray-400"
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                          />
                        </svg>
                      </div>
                      <h3 className="text-xl font-medium text-gray-700 mb-2">
                        تیکتی یافت نشد
                      </h3>
                      <p className="text-gray-500 max-w-md mx-auto">
                        هنوز هیچ تیکتی ثبت نشده است.
                      </p>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default TicketsList;
